class CollectionShop extends HTMLElement {
  colors;
  weights;
  input;
  image;
  form;
  options;
  variants;
  prices;
  quantityInputs;
  weightLabel;
  quickAdd;
  variantId;
  variant;
  triggers;
  thumbnail;
  quantity;
  quantitySelector;
  colorsWrapper1;
  colorsWrapper2;

  constructor() {
    super();

    this.variants = window.theme.collectionProducts[this.dataset.product];
    
    if (this.dataset.quickAdd !== 'true') {
      return;
    }

    this.colors = this.querySelector('.swatch-element.color') || this.querySelector('.blanket-options_select');
    
    // Find weight swatches only outside the quick-add form (on card surface)
    const allWeights = this.querySelectorAll('.swatch.weight');
    this.weights = null;
    for (let i = 0; i < allWeights.length; i++) {
      if (!allWeights[i].closest('.quick-add-form')) {
        this.weights = allWeights[i];
        break;
      }
    }
    
    this.input = this.querySelector('[name="id"]');
    // Select the main product image, not thumbnails or other images
    // Ensure we only select images within this specific card element
    const cardWrapper = this.querySelector('.card-wrapper');
    if (cardWrapper) {
      this.image = cardWrapper.querySelector('.card__inner .media img.cover-image');
      if (!this.image) {
        this.image = cardWrapper.querySelector('.card .media img.cover-image');
      }
      if (!this.image) {
        this.image = cardWrapper.querySelector('.card__inner .media img:not([class*="quick-add"])');
      }
      if (!this.image) {
        this.image = cardWrapper.querySelector('.media img.cover-image');
      }
      if (!this.image) {
        // Last resort - get first image in .media that's not in quick-add
        const mediaContainer = cardWrapper.querySelector('.card__inner .media, .card .media, .media');
        if (mediaContainer) {
          const images = mediaContainer.querySelectorAll('img');
          for (let img of images) {
            if (!img.closest('.quick-add')) {
              this.image = img;
              break;
            }
          }
        }
      }
    } else {
      // Fallback to original logic if card-wrapper not found
      this.image = this.querySelector('.card__inner .media img.cover-image');
      if (!this.image) {
        this.image = this.querySelector('.card .media img.cover-image');
      }
      if (!this.image) {
        this.image = this.querySelector('.card__inner .media img:not([class*="quick-add"])');
      }
      if (!this.image) {
        this.image = this.querySelector('.media img.cover-image');
      }
    }
    this.form = this.querySelector('.quick-add-form');
    
    // Safely get color and weight values with null checks
    const colorInput = this.colors?.querySelector('input:checked');
    const weightInput = this.weights?.querySelector('input:checked');
    
    if (this.weights && colorInput && weightInput) {
      this.options = [colorInput.value, weightInput.value];
    } else if (colorInput) {
      this.options = [colorInput.value];
    } else {
      this.options = [];
    }
    this.weightLabel = this.querySelector('[data-weight]');
    this.prices = this.querySelectorAll('[data-price]');
    this.quantityInputs = this.querySelectorAll('[data-quantity]');
    this.quickAdd = this.querySelector('.quick-add');
    this.discount = this.dataset.discount;
    this.variantId = this.input ? parseInt(this.input.value) : null;
    this.triggers = this.querySelectorAll('[data-quick-add-trigger]');
    this.thumbnail = this.querySelector('.quick-add-thumbnail img');
    this.quantity = 1;
    this.isGiftCard = this.colors ? this.colors.classList.contains('blanket-options_select') : false;
    this.quantitySelector = this.querySelector('.quantity');
    this.colorsWrapper1 = this.querySelector('.quick-add_colors-1');
    this.colorsWrapper2 = this.querySelector('.quick-add_colors-2');
    this.variant = this.variantId ? this.variants.find(((v) => v.id === this.variantId).bind(this)) : null;
    
    if (this.triggers)
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.handleTrigger.bind(this));
      });
    if (this.quantitySelector)
      this.quantitySelector.addEventListener('click', this.handleQuantity.bind(this));
    if (this.colors) this.colors.addEventListener('change', this.handleColors.bind(this));
    if (this.weights) this.weights.addEventListener('change', this.handleWeights.bind(this));
    if (this.form) this.form.addEventListener('submit', this.handleForm.bind(this));

    if (this.isGiftCard)
      this.colors.addEventListener('click', function (e) {
        if (e.target.tagName === 'INPUT') return; else if (this.colors.hasAttribute('open')) this.colors.removeAttribute('open'); else this.colors.setAttribute('open', '');
      }.bind(this))

    this.showOnlyAvailableSwatches()
  }

    showOnlyAvailableSwatches(type = 'color') {
    if (!this.colors || this.isGiftCard || !window.theme.hideUnavailableWeights || !this.weights || !this.variant?.hasWeight) return;
    if (type === 'color') {
      this.colors.querySelectorAll('input').forEach(color => {
        const find = this.variants.find(variant => variant.options[0] === color.value && variant.available)
        if (!find) color.nextElementSibling.setAttribute('hidden', '')
        else color.nextElementSibling.removeAttribute('hidden')
      })

      if (!this.variant.available) {
        const weight = [...this.weights.querySelectorAll('input')].find(weight => {
          const find = this.variants.find(variant => variant.options[1] === weight.value && variant.available && variant.options[0] === this.variant?.options?.[0])
          return !!find
        })

        weight.nextElementSibling.click()
      } else {
        this.weights.querySelectorAll('input').forEach(weight => {
          const find = this.variants.find(variant => variant.options[1] === weight.value && variant.available && variant.options[0] === this.variant?.options?.[0])
          if (!find) weight.nextElementSibling.setAttribute('hidden', '')
          else weight.nextElementSibling.removeAttribute('hidden')
        })
      }
    } else {
      this.weights.querySelectorAll('input').forEach(weight => {
        const find = this.variants.find(variant => variant.options[1] === weight.value && variant.available && variant.options[0] === this.variant?.options?.[0])
        if (!find) weight.nextElementSibling.setAttribute('hidden', '')
        else weight.nextElementSibling.removeAttribute('hidden')
      })

      if (!this.variant.available) {
        const color = [...this.colors.querySelectorAll('input')].find(color => {
          const find = this.variants.find(variant => variant.options[0] === color.value && variant.available && variant.options[1] === this.variant?.options?.[1])
          return !!find
        })

        color.nextElementSibling.click()
      }
    }
  }

  getTotalPrice() {
    const intPrice = parseInt(this.variant.price.replace('$', ''));
    
    let total = intPrice * this.quantity;
    if (this.discount) {
      const discountAmount = total * (this.discount / 100);
      total -= discountAmount;
    }
    return '$' + Math.round(total);
  }

  switchColors(original) {
    if (window.innerWidth > 989 || (window.innerWidth < 990 && !this.colorsWrapper2))
      return;
    let initial;
    let final;
    if (original) {
      initial = this.colorsWrapper2;
      final = this.colorsWrapper1;
    }
    else {
      initial = this.colorsWrapper1;
      final = this.colorsWrapper2;
    }
    const element = initial.removeChild(initial.querySelector('fieldset'));
    final.appendChild(element);
  }

  handleTrigger() {
    if (this.quickAdd.hasAttribute('open')) {
      this.quickAdd.removeAttribute('open');
      document.body.classList.remove('body_fade');
      document.body.classList.remove('header_fade');
      this.switchColors(true);
    }
    else {
      this.quickAdd.setAttribute('open', '');
      document.body.classList.add('body_fade');
      document.body.classList.add('header_fade');
      this.switchColors(false);
    }
  }

  handleQuantity(e) {
    const el = e.target;
    const isMinus = el.classList.contains('quantity__button-minus');
    const isPlus = el.classList.contains('quantity__button-plus');
    if (el.tagName !== 'BUTTON' || (isMinus && this.quantity === 1) || (isPlus && this.quantity === 99))
      return;
    this.quantity = isMinus ? this.quantity - 1 : isPlus ? this.quantity + 1 : this.quantity;
    this.quantityInputs.forEach((input) => {
      input.value = this.quantity.toString();
    });
    this.form.querySelector('button > [data-price]').innerHTML = this.getTotalPrice();
  }

  findPrimaryImage() {
    const cardWrapper = this.querySelector('.card-wrapper');
    if (cardWrapper) {
      return (
        cardWrapper.querySelector('.cover-image--primary') ||
        cardWrapper.querySelector('.card__inner .media img.cover-image') ||
        cardWrapper.querySelector('.card .media img.cover-image') ||
        cardWrapper.querySelector('.media img.cover-image')
      );
    }

    return (
      this.querySelector('.cover-image--primary') ||
      this.querySelector('.card__inner .media img.cover-image') ||
      this.querySelector('.card .media img.cover-image') ||
      this.querySelector('.media img.cover-image')
    );
  }

  updateCardImages() {
    if (!this.variant) return;

    if (!this.image || !this.contains(this.image)) {
      this.image = this.findPrimaryImage();
    }

    if (this.variant.image && this.image && this.contains(this.image)) {
      if (this.image.hasAttribute('srcset')) {
        this.image.removeAttribute('srcset');
      }

      if (this.image.hasAttribute('loading')) {
        this.image.removeAttribute('loading');
      }

      this.image.src = '';
      requestAnimationFrame(() => {
        if (this.image && this.contains(this.image)) {
          this.image.src = this.variant.image;
        }
      });
    }

    const hoverImage = this.querySelector('.cover-image--hover');
    if (hoverImage && this.variant.lifestyleImage) {
      hoverImage.src = this.variant.lifestyleImage;
      hoverImage.removeAttribute('hidden');
      hoverImage.closest('.media')?.classList.add('media--has-secondary-image');
    }
  }

  handleColors(e) {
    // The change event fires on the input, but e.target might be label in some browsers
    // Find the checked input to get the correct value
    const checkedInput = this.colors.querySelector('input:checked');
    
    if (!checkedInput || !checkedInput.value) {
      return;
    }

    if (!this.dataset.skipColorSync && !this.dataset.singleColor) {
      document.dispatchEvent(new CustomEvent('collection:color-selected', {
        detail: {
          color: checkedInput.value,
          source: this,
        },
      }));
    }
    
    this.options[0] = checkedInput.value;

    if (this.isGiftCard) {
      this.variant = this.variants.find((vari) => vari.options[0] === this.options[0] && vari.options[1] === this.options[1]);
    }
    else {
      const oldSizes = this.variant?.sizes?.join(',') || '';
      
      // Reset variant to ensure we find the correct one
      let foundVariant = null;
      
      // If we have weight swatches on card surface AND a selected weight, try to find exact match
      if (this.weights && this.options[1]) {
        foundVariant = this.variants.find((vari) => vari.options[0] === this.options[0] && vari.options[1] === this.options[1]);
      }
      
      // If no exact match, find first variant for this color (preferably available)
      if (!foundVariant) {
        // First try to find an available variant with this color
        foundVariant = this.variants.find((vari) => vari.options[0] === this.options[0] && vari.available);
        // If no available variant, just get first variant with this color
        if (!foundVariant) {
          foundVariant = this.variants.find((vari) => vari.options[0] === this.options[0]);
        }
      }
      
      this.variant = foundVariant;
      
      // Update the selected weight in options array if variant has one
      if (this.variant && this.variant.options[1]) {
        this.options[1] = this.variant.options[1];
      }
      
      // Only update weight swatch if there are weight swatches on the card surface
      if (this.weights && this.variant?.sizes && oldSizes !== this.variant.sizes.join(',')) {
        const input = this.weights.querySelector('input[value="' + this.variant.options[1] + '"]');
        if (input) {
          input.click();
        }
      }

      this.updateCardImages();
      if (this.thumbnail && this.variant?.original_image) {
        this.thumbnail.src = this.variant.original_image;
      }
    }

    
    
    if (!this.variant) return;

    this.input.value = this.variant.id;
    if (this.variant.id == '44420337828026' || this.variant.id == '44420338254010' || this.variant.id == '44420338647226' ) {
      this.prices.forEach((price) => {
        price.innerHTML = price.parentElement.tagName === 'BUTTON' ? '$49' : '$49';
      });
    }
    else {
      this.prices.forEach((price) => {
        price.innerHTML = price.parentElement.tagName === 'BUTTON' ? this.getTotalPrice() : this.variant.price;
      });
    }
    if (this.variant.available)
      this.removeAttribute('soldout');
    else
      this.setAttribute('soldout', '');

    this.showOnlyAvailableSwatches()
  }

  handleWeights(e) {
    this.options[1] = e.target.value;
    this.variant = this.variants.find((variant) => variant.options[0] === this.options[0] && variant.options[1] === this.options[1]);
    this.input.value = this.variant.id;

    if (this.variant.hasWeight)
      this.weightLabel.innerHTML = this.options[1] + ' lbs ' + window.theme.getDimension(this.options[1]);
    else if (this.variant.hasSize && !this.isGiftCard) {
      let option = this.options[1];
      if (option === 'Small' && this.variant.title === 'Pupper Pod') option = 'Small1';
      else if (option === 'Medium' && this.variant.title === 'Pupper Pod') option = 'Medium1';
      this.weightLabel.innerHTML = this.options[1] + window.theme.getDimension(option);
    } else
      this.weightLabel.innerHTML = this.options[1];

    this.prices.forEach(((price) => {
      if (this.variant.options[0] == 'Kaleidoscope' || this.variant.options[0] == 'Flora' || this.variant.options[0] == 'Mist'  ) {
        price.innerHTML = price.parentElement.tagName === 'BUTTON' ? '$49' : '$49';
      } else {
      price.innerHTML = price.parentElement.tagName === 'BUTTON' ? this.getTotalPrice() : this.variant.price;
      }
    }).bind(this));

    if (this.variant.image) {
      this.updateCardImages();
    }

    if (this.variant.available)
      this.removeAttribute('soldout');
    else
      this.setAttribute('soldout', '');

    this.showOnlyAvailableSwatches('weight')
  }

  handleForm(e) {
    e.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute('disabled', 'true');
    submitButton.classList.add('loading');
    const body = JSON.stringify({
      ...JSON.parse(window.theme.utils.serializeForm(this.form))
    });
    fetch('/cart/add', { ...window.theme.fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        window.theme.cart.render(true);
      })
      .catch((err) => {
        console.error(err);
        e.target.submit();
      })
      .finally(() => {
        this.quickAdd.removeAttribute('open');
        this.switchColors(true);
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

if (!customElements.get('collection-shop')) {
  customElements.define('collection-shop', CollectionShop);
}

class CollectionColorGroup {
  static COLOR_PRIORITY = [
    'Cloud White',
    'Sweet Lavender',
    'Morning Pearl',
    'Lemon Icing',
    'Moonstone Grey',
    'Asteroid Grey',
  ];

  constructor(grid) {
    this.grid = grid;
    this.syncing = false;
    this.userSelectedColor = null;
    this.colorPriority = this.parseColorOrder(
      grid.closest('[data-color-order]')?.dataset.colorOrder ||
        grid.dataset.colorOrder ||
        ''
    );
  }

  parseColorOrder(raw) {
    if (!raw || !String(raw).trim()) {
      return [...CollectionColorGroup.COLOR_PRIORITY];
    }

    const parsed = String(raw)
      .split(/[\n,]+/)
      .map((color) => color.trim())
      .filter(Boolean);

    return parsed.length ? parsed : [...CollectionColorGroup.COLOR_PRIORITY];
  }

  sortColors(colors) {
    return [...colors].sort((a, b) => {
      const aIndex = this.colorPriority.indexOf(a);
      const bIndex = this.colorPriority.indexOf(b);

      if (aIndex === -1 && bIndex === -1) return a.localeCompare(b);
      if (aIndex === -1) return 1;
      if (bIndex === -1) return -1;
      return aIndex - bIndex;
    });
  }

  getAllColorsInGrid() {
    const colors = new Set();
    this.getProductCards().forEach((card) => {
      this.getCardColors(card).forEach((color) => colors.add(color));
    });
    return this.sortColors([...colors]);
  }

  getVariantForCard(card) {
    const shop = card.querySelector('collection-shop');
    const handle = shop?.dataset.product;
    const color = this.getActiveColor(card);
    const variants = window.theme.collectionProducts?.[handle];

    if (!variants || !color) return null;

    return (
      variants.find((variant) => variant.options[0] === color && variant.available) ||
      variants.find((variant) => variant.options[0] === color)
    );
  }

  setCardImage(card, src) {
    const shop = card.querySelector('collection-shop');
    const image =
      shop?.querySelector('.cover-image--primary') ||
      shop?.querySelector('.cover-image');
    if (!image || !src) return;

    if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
    image.src = src;

    const hoverImage = shop?.querySelector('.cover-image--hover');
    const variant = this.getVariantForCard(card);
    if (hoverImage && variant?.lifestyleImage) {
      hoverImage.src = variant.lifestyleImage;
      hoverImage.removeAttribute('hidden');
      hoverImage.closest('.media')?.classList.add('media--has-secondary-image');
    }
  }

  applyLifestyleImages() {
    const items = [...this.grid.querySelectorAll('.sale-products-item[data-colors]:not(.hidden)')].sort(
      (a, b) => (parseInt(a.style.order, 10) || 0) - (parseInt(b.style.order, 10) || 0)
    );
    const colorGroups = new Map();

    items.forEach((card) => {
      const color = this.getActiveColor(card) || '';
      if (!colorGroups.has(color)) colorGroups.set(color, []);
      colorGroups.get(color).push(card);
    });

    this.sortColors([...colorGroups.keys()]).forEach((color) => {
      colorGroups.get(color).forEach((card) => {
        const variant = this.getVariantForCard(card);
        if (!variant) return;

        card.classList.remove('sale-products-item--lifestyle-lead');
        this.setCardImage(card, variant.image);
        card.dataset.showingLifestyle = 'false';
      });
    });
  }

  assignPriorityColors() {
    if (this.userSelectedColor) return;

    const priorityColors = this.getAllColorsInGrid();

    this.getProductCards().forEach((card) => {
      if (card.classList.contains('hidden')) return;

      const cardColors = this.getCardColors(card);
      const assignedColor = priorityColors.find((color) => cardColors.includes(color));

      if (assignedColor) this.setCardColor(card, assignedColor);
    });
  }

  refreshGrid() {
    this.groupByActiveColor();
    this.applyLifestyleImages();
  }

  getProductCards() {
    return [...this.grid.querySelectorAll('.sale-products-item[data-colors]')];
  }

  getActiveColor(card) {
    if (card.dataset.activeColor) return card.dataset.activeColor;
    const shop = card.querySelector('collection-shop');
    if (!shop) return null;
    const checked = shop.querySelector('.swatch-element.color input:checked');
    return checked?.value || null;
  }

  getCardColors(card) {
    const colors = card.getAttribute('data-colors');
    return colors ? colors.split(',').map((color) => color.trim()).filter(Boolean) : [];
  }

  hasColor(card, color) {
    return this.getCardColors(card).includes(color);
  }

  setCardColor(card, color) {
    const shop = card.querySelector('collection-shop');
    if (!shop || !this.hasColor(card, color)) return false;

    const current = this.getActiveColor(card);
    if (current === color) return true;

    const input = [...shop.querySelectorAll('.swatch-element.color input')].find(
      (swatchInput) => swatchInput.value === color
    );

    if (!input || input.checked) return !!input;

    shop.dataset.skipColorSync = 'true';
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    delete shop.dataset.skipColorSync;
    return true;
  }

  groupByActiveColor() {
    const items = [...this.grid.children];
    const productItems = items.filter(
      (el) => el.matches('.sale-products-item[data-colors]') && !el.classList.contains('hidden')
    );
    const otherItems = items.filter(
      (el) => !el.matches('.sale-products-item[data-colors]') || el.classList.contains('hidden')
    );

    const colorGroups = new Map();
    productItems.forEach((card) => {
      const color = this.getActiveColor(card) || '';
      if (!colorGroups.has(color)) colorGroups.set(color, []);
      colorGroups.get(color).push(card);
    });

    const sortedColors = this.sortColors([...colorGroups.keys()]);
    let order = 1;

    sortedColors.forEach((color) => {
      colorGroups.get(color).forEach((card) => {
        card.style.order = order;
        card.dataset.activeColor = color;
        order += 1;
      });
    });

    otherItems.forEach((el) => {
      el.style.order = order;
      order += 1;
    });
  }

  syncToColor(color, sourceCard = null) {
    if (this.syncing || !color) return;
    this.syncing = true;
    this.userSelectedColor = color;

    this.getProductCards().forEach((card) => {
      if (card === sourceCard || card.classList.contains('hidden')) return;
      this.setCardColor(card, color);
    });

    this.refreshGrid();
    this.syncing = false;
  }
}

function initCollectionColorGroups() {
  if (!window.theme) window.theme = {};
  window.theme.collectionColorGroups = [];

  if (document.querySelector('[data-color-split="true"]')) {
    return;
  }

  document.querySelectorAll('[data-color-grouping="true"] .sale-products').forEach((grid) => {
    const group = new CollectionColorGroup(grid);
    window.theme.collectionColorGroups.push(group);
    requestAnimationFrame(() => {
      group.assignPriorityColors();
      group.refreshGrid();
    });
  });
}

if (!window.theme?.collectionColorGroupListenerAttached) {
  document.addEventListener('collection:color-selected', (event) => {
    window.theme?.collectionColorGroups?.forEach((group) => {
      const card = event.detail.source?.closest('.sale-products-item');
      if (!card || !group.grid.contains(card)) return;
      group.syncToColor(event.detail.color, card);
    });
  });
  if (!window.theme) window.theme = {};
  window.theme.collectionColorGroupListenerAttached = true;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionColorGroups);
} else {
  initCollectionColorGroups();
}

document.addEventListener('shopify:section:load', initCollectionColorGroups);

document.querySelectorAll('.quick-add').forEach(element => {
  element.addEventListener('click', function() {
      setTimeout(() => {
          this.classList.add('active-click');
      }, 500);
  });
});
